export default class Tool {
  event
  config
  container
  pixiObj
  options
  vm // vue object
  update(event, config, container, pixiObj, options, vm) {
    this.event = event
    this.config = config
    this.container = container
    this.pixiObj = pixiObj
    this.options = options
    this.vm = vm
  }
  mouseDown(event) {}
  mouseUp(event) {}
  mouseWheel(event) {}
  mouseMove(event) {}
  mouseLeave(event) {}
  $msg(data) {
    this.vm.$emit('tool-msg', data)
  }
}
